import { Person } from "js/pages/Tenants/types";

export interface TenantOption {
  label: string;
  value: string;
  fields: Person;
}

export interface SeparatedTenants {
  naturalPersons: TenantOption[];
  legalPersons: TenantOption[];
}

/**
 * Separates tenants into natural and legal persons with formatted labels
 * @param tenants - Array of Person objects from API
 * @returns Object containing separated tenant arrays
 */
export const separateAndFormatTenants = (
  tenants: Person[],
): SeparatedTenants => {
  const naturalPersons: TenantOption[] = [];
  const legalPersons: TenantOption[] = [];

  tenants.forEach((person: Person) => {
    if (person.legal_type === "Natural") {
      naturalPersons.push({
        label:
          `${person.name} ${person.first_surname} ${person.second_surname || ""}`.trim() +
          (person.rfc ? ` - ${person.rfc}` : ""),
        value: person.id,
        fields: person,
      });
    } else {
      const representativeName =
        `${person.name} ${person.first_surname} ${person.second_surname || ""}`.trim();
      const legalEntityInfo = person.legal_entity_name || "";
      const rfcInfo = person.rfc ? ` - ${person.rfc}` : "";

      legalPersons.push({
        label: `${representativeName}${legalEntityInfo ? ` (${legalEntityInfo}${rfcInfo})` : rfcInfo}`,
        value: person.id,
        fields: person,
      });
    }
  });

  return {
    naturalPersons,
    legalPersons,
  };
};
